import { render, staticRenderFns } from "./draftList.vue?vue&type=template&id=944ba594&scoped=true&"
import script from "./draftList.vue?vue&type=script&lang=js&"
export * from "./draftList.vue?vue&type=script&lang=js&"
import style0 from "./draftList.vue?vue&type=style&index=0&id=944ba594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944ba594",
  null
  
)

export default component.exports